import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import MobileMyDocumentsCard from '../components/MobileMyDocumentsCard';
import './MobileCourseDocumentsPage.css';

export default function MobileCourseDocumentsPage(){
  const { courseId } = useParams();

  useEffect(() => {
    // hide any duplicated bottom "Docs" button variants on this page
    const selectors = [
      '.docs-button-wrap',
      '.docs-btn',
      '.mobile-bottom-docs',
      'button[aria-label="Docs"]',
      'button[data-role="docs"]'
    ].join(',');
    const els = Array.from(document.querySelectorAll(selectors));
    els.forEach(el => {
      // keep a mark so we can restore if needed
      el.dataset._origDisplay = el.style.display || '';
      el.style.display = 'none';
      el.style.visibility = 'hidden';
      el.style.pointerEvents = 'none';
    });
    return () => {
      // restore original display on unmount
      els.forEach(el => {
        if (el.dataset && typeof el.dataset._origDisplay !== 'undefined') {
          el.style.display = el.dataset._origDisplay;
          el.style.visibility = '';
          el.style.pointerEvents = '';
          delete el.dataset._origDisplay;
        }
      });
    };
  }, []);

  return (
    <div className="m-screen mobile-course-docs-screen">
      <h2 className="m-subtitle">Course Documents</h2>
      <MobileMyDocumentsCard selectionMode={false} endeavorId={courseId} />
    </div>
  );
}